export default "__VITE_ASSET__3d39GnZT__"